module.exports = __webpack_public_path__ + "img/hk_feature6.26e626ce.jpg";